import { ReactNode } from "react"

interface AppContentProps {
  children: ReactNode
}

export function AppContent({ children }: AppContentProps) {
  return (
    <main className="relative flex-1 overflow-auto px-4 py-5 lg:px-8 lg:py-8">
      <div className="mx-auto w-full max-w-7xl">{children}</div>
    </main>
  )
}
